const CORS_PROXY = 'https://cors-proxy.utils.elfsightcdn.com/';

export const getCORSProxyLink = (
  link: string,
  widgetToken?: string,
  withToken = true
) => {
  if (!widgetToken) {
    return link;
  }

  const resultLink = new URL(CORS_PROXY);
  resultLink.searchParams.append('url', link);
  if (withToken) {
    resultLink.searchParams.append('widgetToken', widgetToken);
  }

  return resultLink.toString();
};
